// extracted by mini-css-extract-plugin
export default {"btnContent":"activation_btnContent__lymH9"};